var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1009 12.2911C9.93347 13.2156 8.45949 13.7673 6.85714 13.7673C3.07005 13.7673 0 10.6854 0 6.88365C0 3.08192 3.07005 0 6.85714 0C10.6442 0 13.7143 3.08192 13.7143 6.88365C13.7143 8.45657 13.1888 9.90627 12.3044 11.0655L17.749 16.5311C18.0837 16.8671 18.0837 17.4119 17.749 17.748C17.4142 18.084 16.8715 18.084 16.5368 17.748L11.1009 12.2911ZM12 6.88365C12 9.73496 9.69746 12.0464 6.85714 12.0464C4.01682 12.0464 1.71429 9.73496 1.71429 6.88365C1.71429 4.03235 4.01682 1.72091 6.85714 1.72091C9.69746 1.72091 12 4.03235 12 6.88365Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d5157c3abb8c54f689d7f52608c2378f.svg";
export { ForwardRef as ReactComponent };